import { IHintShortcutGroup } from '@shared/dto/hint_shortcuts/i_hint_shortcut_group';
import { ViewAllHintsShortcutsGroupHeader } from './ViewAllHintsShortcutsGroupHeader';
import { ViewAllHintsShortcutsGroupItem } from './ViewAllHintsShortcutsGroupItem';

interface Props {
  item: IHintShortcutGroup;
}

export function ViewAllHintsShortcutsGroup({ item }: Props) {
  let { group } = item;

  function render_items() {
    return item.items.map((hint_data, index) => {
      return <ViewAllHintsShortcutsGroupItem key={`all_hints_shortcut_group_item_${group}_${index}`} {...{ hint_data }} />;
    });
  }

  return (
    <div className="flex flex-col gap-4">
      <ViewAllHintsShortcutsGroupHeader {...{ group }} />

      {render_items()}
    </div>
  );
}
